import { useEffect, useState } from 'react';
import { Alert } from 'antd';
import { WifiOutlined } from '@ant-design/icons';
import styles from './NetworkErrorBanner.module.scss';

const NetworkErrorBanner = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Keep banner visible for 2 seconds to show "reconnected" message
      setTimeout(() => setShowBanner(false), 2000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) {
    return null;
  }

  return (
    <div className={styles.network_banner}>
      <Alert
        message={
          isOnline ? (
            <span>
              <WifiOutlined /> Connection restored
            </span>
          ) : (
            <span>
              <WifiOutlined /> No internet connection. Please check your network.
            </span>
          )
        }
        type={isOnline ? 'success' : 'error'}
        banner
        closable={isOnline}
        onClose={() => setShowBanner(false)}
      />
    </div>
  );
};

export default NetworkErrorBanner;
